import { css } from 'aphrodite';
import { useLocation } from 'react-router';
import { StatusBanner } from '../components/StatusBanner';
import { styleSheet } from './styles';

export const showsGamification = (pathname?: string) =>
	!!pathname &&
	!pathname.includes('settings') &&
	!pathname.includes('reporting') &&
	!pathname.includes('ai-coaching-review');

export const CoffeeSubBar = ({ dialer }: { dialer?: React.ReactNode }) => {
	const { pathname } = useLocation();
	if (!showsGamification(pathname)) {
		return null;
	}
	return (
		<div className={css(styleSheet.subBar)}>
			<StatusBanner styles={[styleSheet.statusBannerInGrid]} dialer={dialer} shellV2 />
		</div>
	);
};
